function exitDetect(callback) {
    let out;
    $(document).on("mouseleave", function (e) {
        if (e.originalEvent.clientY === -1 && out !== 1) {
            callback();
            out = 1;
        }
    });
}